import React from 'react';
import { useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import { GET_IMAGES } from '../graphql/queries';
import { DataTable } from '../components/DataTable';
import OsIcon, { AmiImageIcon } from '../components/OsIcon';
import { formatArch } from '../utils/os-icons';

function statusBadge(status) {
  const map = { completed: 'success', building: 'info', failed: 'error', scanning: 'warning', pending: 'pending' };
  return <span className={`badge badge-${map[status] || 'pending'}`}>{status}</span>;
}

const columns = [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) => (
      <Link to={`/images/${row.original.id}`} className="link">{row.original.name}</Link>
    ),
  },
  { accessorKey: 'blueprintName', header: 'Blueprint', cell: ({ getValue }) => <OsIcon name={getValue()} showLabel /> },
  { accessorKey: 'blueprintVersion', header: 'Version' },
  { accessorKey: 'imageType', header: 'Type' },
  { accessorKey: 'osType', header: 'OS', cell: ({ row }) => <OsIcon name={row.original.blueprintName || row.original.osType} size={18} /> },
  { accessorKey: 'architecture', header: 'Arch', cell: ({ getValue }) => formatArch(getValue()) },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ getValue }) => statusBadge(getValue()),
  },
  {
    accessorKey: 'createdAt',
    header: 'Created',
    cell: ({ getValue }) => getValue() ? new Date(getValue()).toLocaleDateString() : '-',
  },
  {
    id: 'actions',
    header: 'Actions',
    cell: ({ row }) => (
      <Link to={`/compliance/${row.original.id}`} className="link" style={{ fontSize: 12 }}>
        Compliance
      </Link>
    ),
  },
];

export default function ImageList() {
  const { data, loading, error, fetchMore } = useQuery(GET_IMAGES, { variables: { limit: 50, filter: {} } });

  if (loading) return <div className="loading">Loading images...</div>;
  if (error) return <div className="error">Failed to load images: {error.message}</div>;

  const images = data?.listImages?.items || [];
  const nextToken = data?.listImages?.nextToken;

  return (
    <div>
      <h2 className="page-title"><AmiImageIcon size={24} /> Images</h2>
      <div className="card">
        {images.length === 0 ? (
          <p>No images found. <Link to="/build" className="link">Trigger a build</Link> to get started.</p>
        ) : (
          <>
            <DataTable
              columns={columns}
              data={images}
              searchPlaceholder="Search by name, blueprint, or AMI ID..."
            />
            {nextToken && (
              <div style={{ textAlign: 'center', marginTop: 16 }}>
                <button className="btn btn-primary" onClick={() => fetchMore({ variables: { nextToken } })}>Load More</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
